import { EnvironmentService } from 'shared/services';

export const getQrCheckoutDeeplinkUrl = (workItemId: string) => {
  return `${EnvironmentService.getVariable('QR_CHECKOUT_DEEPLINK_URL')}?workId=${workItemId}`;
};
